import { createContext, useContext } from "react";
import { GPU } from "userful-chronos-app-common-js/dist/models/ve/videoEngines";

export interface LicensedGPUsState {
    gpus: GPU[];
}

export const initState: LicensedGPUsState = {
    gpus: [],
};

export const LicensedGPUContext = createContext<LicensedGPUsState>(initState);

LicensedGPUContext.displayName = "LicensedGPUContext";

export function useLicensedGPUContext(): LicensedGPUsState {
    const context = useContext(LicensedGPUContext);

    if (!context) {
        throw new Error("useLicensedGPUContext must be used within a LicensedGPUProvider");
    }

    return context;
}
